<template>
    <dialog-fullscreen :visibility.sync = 'visibility' :indicator = 'indicator'>
		<template v-slot:title>Создание пользователя</template>
		<template v-slot:action>
			<v-btn 
				text 
				:disabled = '!valid'
				:loading = 'indicator'
				color='green darken-2' 
				@click = 'createPerson'
			>
                Создать
            </v-btn>
		</template>
        <template v-slot:content>
			<v-form v-model = 'valid' style = 'min-width: 320px; max-width: 420px;'>
                <v-text-field 
                    v-model = "user.name" 
                    label = "Имя" 
                    :rules = "[rules.required]"
                ></v-text-field>
                <v-text-field 
                    v-model = "user.lastname" 
                    label = "Фамилия" 
                    :rules = "[rules.required]"
                ></v-text-field>
                <v-text-field 
                    v-model = "user.email" 
                    label = "Почта" 
                    :rules = "[rules.required, rules.email, rules.forbiddenLogins]"
                    validate-on-blur
                ></v-text-field>
                <v-select 
                    v-model = 'user.language' 
                    :items = "[{ 'value': 'ru', 'text': 'Русский' }, { 'value': 'en', 'text': 'Английский' }]" 
                    item-text = "text" 
                    item-value = "value" 
                    label = "Язык" 
                    hint = "Язык" 
                    single-line 
                    persistent-hint
                ></v-select>
                <v-select 
                    v-model = 'user.mode_users' 
                    :items = 'modeUsers' 
                    item-text = "text" 
                    item-value = "value" 
                    label = "Управление пользователями" 
                    single-line 
                    persistent-hint 
                    hint = "Управление пользователями"
                ></v-select>
                <v-select 
                    v-model = 'user.mode_projects' 
                    :items = '[{"text": "Просмотр доступных", "value": 0},{"text": "Создание, изменение и удаление", "value": 1}]' 
                    item-text = "text" 
                    item-value = "value" 
                    label = "Управление проектами" 
                    single-line 
                    persistent-hint 
                    hint = "Управление проектами"
                ></v-select>
                <v-select 
                    v-model = 'user.mode_reports' 
                    :items = '[{"text": "Просмотр доступных", "value": 0},{"text": "Создание, изменение и удаление", "value": 1}]' 
                    item-text = "text" 
                    item-value = "value" 
                    label = "Управление отчетами" 
                    single-line 
                    persistent-hint 
                    hint = "Управление отчетами"
                ></v-select>
                <v-select 
                    v-if = '$store.getters.grantUsers > 2' 
                    v-model = 'user.domain' 
                    :items = '[{"text": "Artics Internet Solutions", "value": "artics"},{"text": "Daskipper Digital", "value": "daskipper"},{"text": "Не ограничена", "value": "*"}]' 
                    item-text = "text" 
                    item-value = "value" 
                    label = "Область действия" 
                    hint = 'Область действия' 
                    single-line 
                    persistent-hint
                ></v-select>
			</v-form>
        </template>
    </dialog-fullscreen>
</template>
<script>
    import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue'

    export default {
        name: 'UserCreate',
        props: ['initialState', 'postAction', 'restricted'],
        components: {'dialog-fullscreen': DialogFullscreen},
        data() {
            return {
                valid: false,
                visibility: this.initialState,
                indicator: false,
                errorCreate: false,
                errorCreateMessage: '',
                user: {},
                modeUsers: [
                    {'text': 'Доступ закрыт', 'value': 0},
                    {'text': 'Просмотр списка', 'value': 1},
                    {'text': 'Создание (в своем домене)', 'value': 2},
                    {'text': 'Создание (для всех доменов)', 'value': 3},
                    {'text': 'Редактирование', 'value': 4},
                    {'text': 'Полный доступ', 'value': 5}
                ],
                rules: {
                    required: value => !!value || 'Обязательное поле',
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Неправильный e-mail'
                    },
                    forbiddenLogins: value => !(this.restricted || []).includes(value) || 'Аккаунт с указанным почтовым адресом уже существует'
                }
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value;
            },
            visibility(value) {
                this.$emit('update:initialState', value);
                if (value) {
                    this.user.domain = this.$store.state.brandingOption
                }
            }
        },
        methods: {
            generatePassword: function(length) {
                let password = '';
                let chunkAlfa = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                let chunkNumbers = '0123456789';
                let chunkSymbols = '!@#$%^&*()?<>~';
                let charsBase = chunkAlfa + chunkNumbers + chunkSymbols;
                for (let i = 0; i < length; i++) {
                    let char_idx = Math.floor(Math.random() * charsBase.length);
                    password += charsBase[char_idx]
                }
                this.user['password'] = password;
                return password;
            },
            createPerson() {
                this.indicator = true;
                this.generatePassword(8)
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                this.$http.post(this.$store.getters.endpoint + '/db/persons', {
                    ...{ 'login': this.$store.getters.userLogin, 'user': this.user }
                }, {
                    headers: { ...this.$store.state.restrictedHeaders,
                        ...requestHeaders
                    }
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.indicator = false;
                        this.user = {}
                        this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'create',
                                target: 'user'
                            },
                            once: false
                        })
                        this.postAction();
                        this.visibility = false;
                    } else {
                        console.log(response)
                    }
                })
            }
        }
    }
</script>